export const getFilterText = (code: string) => {
  switch (code) {
    case 'excludePreOrder':
      return '예약제외';
    case 'freeDelivery':
      return '무료배송';
    default:
      return '';
  }
};
